<div class="retool-state" [style.height.px]="contentHeight()">
  <!-- Horizontal Splitter: Left Sidebar | Right Details -->
  <ejs-splitter height='100%' separatorSize=2 width='100%' orientation='Horizontal'>
    <e-panes>
      <!-- Left Pane: Sidebar with Tree -->
      <e-pane size='20%' min='100px'>
        <ng-template #content>
          <div class="state-sidebar">
            <div class="sidebar-header">
              <span class="search-icon fa fa-search"></span>
              <input
                type="text"
                class="search-input"
                placeholder="Search plugins"
                [value]="searchQuery()"
                (input)="searchQuery.set($any($event.target).value)"
              />
            </div>

            <div class="state-content">
              @if (treeItems().length === 0 && searchQuery().trim().length > 0) {
                <div class="no-results">
                  <div class="no-results-icon">🔍</div>
                  <div class="no-results-text">No results found</div>
                </div>
              } @else {
                @for (item of treeItems(); track item.path) {
                  <div
                    class="tree-item"
                    [class.tree-section]="item.type === 'section'"
                    [class.tree-parent-item]="item.type === 'parent-item'"
                    [class.tree-parent-group]="item.type === 'parent-group'"
                    [class.tree-leaf-item]="item.type === 'leaf-item'"
                    [class.tree-selected]="selectedPath() === item.path"
                    [class.tree-clickable]="item.type !== 'section'"
                    [style.padding-left.px]="(item.indent || 1) * 8 + (item.type === 'leaf-item' && (item.indent || 1) > 1 ? 16 : 0)"
                    (click)="item.type !== 'section' ? handleRowClick(item) : null"
                  >
                    <!-- Expand/Collapse Arrow (for parent items and groups) -->
                    @if (item.type === 'parent-item' || item.type === 'parent-group') {
                      @if (item.hasChildren) {
                        <span
                          class="tree-arrow"
                          [class.expanded]="isExpanded(item.path)"
                        >
                          <i class="fa fa-chevron-right"></i>
                        </span>
                      } @else {
                        <span class="tree-arrow-placeholder"></span>
                      }
                    }

                    <!-- Item Label -->
                    <span class="tree-label">
                      {{ item.label }}
                    </span>
                  </div>
                }
              }
            </div>
          </div>
        </ng-template>
      </e-pane>

      <!-- Right Pane: Details with Tabs -->
      <e-pane size='80%' min='300px'>
        <ng-template #content>
          <div class="state-main">
            @if (selectedData()) {
              <div class="state-header">
                <div class="header-left">
                  <span class="state-icon" [class]="selectedIcon()"></span>
                  <span class="state-name">{{ selectedDisplayName() }}</span>
                </div>
                <div class="header-right">
                  @if (isSelectedItemScreen()) {
                    <span
                      class="edit-designer-icon fa fa-pencil"
                      (click)="openScreenInDesigner()"
                      title="Edit in Designer"
                    ></span>
                  }
                  <span
                    class="search-toggle-icon fa fa-search"
                    (click)="toggleJsonSearch()"
                    [class.active]="showJsonSearch()"
                    title="Search"
                  ></span>
                </div>
              </div>

              <!-- Tabs for Query View -->
              @if (isSelectedItemQueryComputed()) {
                <div class="tab-bar">
                  <button
                    class="tab-button"
                    [class.active]="activeTab() === 'json'"
                    (click)="switchTab('json')"
                  >
                    <span class="fa fa-code"></span>
                    <span class="tab-label">JSON</span>
                  </button>
                  <button
                    class="tab-button"
                    [class.active]="activeTab() === 'edit'"
                    (click)="switchTab('edit')"
                  >
                    <span class="fa fa-edit"></span>
                    <span class="tab-label">Edit</span>
                  </button>
                  <button
                    class="tab-button"
                    [class.active]="activeTab() === 'run'"
                    (click)="switchTab('run')"
                  >
                    <span class="fa fa-play"></span>
                    <span class="tab-label">Run</span>
                  </button>
                </div>
              }

              <!-- Tabs for Script View -->
              @if (isSelectedItemScriptComputed()) {
                <div class="tab-bar">
                  <button
                    class="tab-button"
                    [class.active]="activeTab() === 'json'"
                    (click)="switchTab('json')"
                  >
                    <span class="fa fa-code"></span>
                    <span class="tab-label">JSON</span>
                  </button>
                  <button
                    class="tab-button"
                    [class.active]="activeTab() === 'edit'"
                    (click)="switchTab('edit')"
                  >
                    <span class="fa fa-edit"></span>
                    <span class="tab-label">Edit</span>
                  </button>
                </div>
              }

              @if (showJsonSearch() && activeTab() === 'json') {
                <div class="search-bar-bottom">
                  <input
                    type="text"
                    class="search-input"
                    placeholder="Search"
                    (input)="setJsonSearchQuery($any($event.target).value)"
                    #searchInput
                    autofocus
                  />
                </div>
              }

              <div class="state-content-area">
                <!-- JSON Tab Content -->
                @if ((!isSelectedItemQueryComputed() && !isSelectedItemScriptComputed()) || activeTab() === 'json') {
                  <div class="state-json">
                    <app-json-tree [data]="selectedData()" [searchQuery]="jsonSearchQuery()" />
                  </div>
                }

                <!-- Query Edit Tab Content -->
                @if (isSelectedItemQueryComputed() && activeTab() === 'edit') {
                  <div class="state-renderer">
                    <tab-form-renderer #editRenderer [screenRenderingMode]="'DevToolScreen'"></tab-form-renderer>
                  </div>
                }

                <!-- Query Run Tab Content -->
                @if (isSelectedItemQueryComputed() && activeTab() === 'run') {
                  <div class="state-renderer">
                    <tab-form-renderer #runRenderer [screenRenderingMode]="'DevToolScreen'"></tab-form-renderer>
                  </div>
                }

                <!-- Script Edit Tab Content -->
                @if (isSelectedItemScriptComputed() && activeTab() === 'edit') {
                  <div class="state-renderer">
                    <tab-form-renderer #scriptEditRenderer [screenRenderingMode]="'DevToolScreen'"></tab-form-renderer>
                  </div>
                }
              </div>
            } @else {
              <div class="empty-state">
                <div class="empty-icon">📊</div>
                <div class="empty-text">Select an item to view its state</div>
              </div>
            }
          </div>
        </ng-template>
      </e-pane>
    </e-panes>
  </ejs-splitter>
</div>